import { configureStore } from '@reduxjs/toolkit'
import { snackBarSlice } from './Slices/ToastSlice'
import { headerSlice } from './Slices/headerDataSlice'

export const store = configureStore({
  reducer: {
    toast:snackBarSlice.reducer,
    header:headerSlice.reducer
  },
})